import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import action from "../../../../../actions";
import DEFINE from '../../../../../constants/Define';
import * as HMS from "../../../common/component/Index";
import * as ANT from 'antd';
import $ from 'jquery'
import moment from 'moment'
import { get } from 'lodash'
import AntSelect, { AntOption } from '../../../common/component/AntSelect';

const defaultValue = {
    allGroups: [],
    isSubmit: false,
    data: {},
    onAction: false,
    importErrors: [],
    importData: {}
};

class ImportComponent extends Component {

    state = defaultValue;

    componentDidMount() {
        this.setState({ importErrors: [] });
        this.props.onListAllGroups();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.vouchers) {
            this.setState({
                isSubmit: nextProps.vouchers.isSubmit,
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.vouchers.importErrors !== prevProps.vouchers.importErrors) {
            this.setState({
                importErrors: this.props.vouchers.importErrors,
                importData: this.props.vouchers.importData,
            });
        }
        if (this.props.groups !== prevProps.groups) {
            let newData = Func.customOptionSelectHMS(this.props.groups.allGroups, ['name', 'id']);
            this.setState({
                allGroups: newData,
            });
        }
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(get(option, 'props.children.props.title').toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    onChange = (e) => {
        this.setState({ importData: {} });
        var target = e.target;
        var name = target.name;
        var value = target.value;
        this.setState({
            data: { ...this.state.data, [name]: value }
        });
        if (target.files) {
            target.files[0].name && $('.titleChosseFile').text(target.files[0].name);
            this.setState({ data: { ...this.state.data, file: target.files[0] } });
        }
    };

    onSubmit = (e) => {
        e.preventDefault();
        this.props.onImportVoucher(this.state.data);
        this.setState({ onAction: true });
    };

    render() {
        const { t } = this.props;
        const { importErrors, importData, data, isSubmit, allGroups } = this.state;
        const loadingAllGroup = this.props.groups.isFetchingUpdate;
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent>
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'vouchers'}
                            titleHeader={t('item.voucher.importVoucher')}
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            findParentRoute={() => Func.findParentRoute('vouchers', this.props)}
                            submitButtonRight={true}
                            isDisableAction={isSubmit || (importData && importData.success)}
                            titleButtonSubmit={t('item.voucher.importData')}
                        >
                            <HMS.FormWrapperItem>
                                <div className="col-md-8 offset-md-2 mt-3">
                                    <div className="col-md-12">
                                        {/* <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            labelTitle={t(`item.group.title`)}
                                        >
                                            <select className="form-control" name="groupId" onChange={this.onChange}
                                                value={Func.checkUndefine(data.groupId)} required>
                                                <option value="">{Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.group.title")).toLowerCase())}</option>
                                                {
                                                    allGroups.length > 0 && allGroups.map((i, k) => {
                                                        return (
                                                            <option value={i.value} key={k}>{i.name}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </HMS.FormWrapperInputComponent> */}
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            labelTitle={t(`item.group.title`)}
                                        >
                                            <AntSelect className="select-group"
                                                showArrow showSearch
                                                loading={loadingAllGroup}
                                                placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.group.title")).toLowerCase())}
                                                value={data.groupId}
                                                onChange={id => this.onChange({ target: { name: 'groupId', value: id } })}
                                                style={{ width: '100%' }}
                                                filterOption={this.selectFilterSearch}
                                            >
                                                {(allGroups || []).map(g => (
                                                    <AntOption key={g.value} value={g.value}>
                                                        <ANT.Tooltip title={g.name} placement="topLeft">{g.name}</ANT.Tooltip>
                                                    </AntOption>
                                                ))}
                                            </AntSelect>
                                        </HMS.FormWrapperInputComponent>
                                    </div>
                                    <div className="col-md-12">
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            labelTitle={t(`item.voucher.chooseFile`)}
                                        >
                                            <div className="custom-file">
                                                <input id="" type="file" className="custom-file-input"
                                                    name="files" onChange={this.onChange}
                                                    onClick={(e) => e.target.value = null} required />
                                                <label htmlFor="logo" className="custom-file-label titleChosseFile" style={{ zIndex: 0 }}>Choose
                                                file...</label>
                                            </div>
                                        </HMS.FormWrapperInputComponent>
                                    </div>
                                    {
                                        importErrors && importErrors.length > 0 && importErrors[0].moreInfo && (
                                            <div className="col-md-12 import-error-contain">

                                                <div className={`import-faild-title`}><h3>{Func.capitalizeFirstLetter(t('item.voucher.importFaild'))} </h3></div>
                                                <div>{Func.capitalizeFirstLetter(t('item.voucher.totalRowInFile'))} {importErrors[0].moreInfo.totalCount}</div>
                                                <div>{Func.capitalizeFirstLetter(t('item.voucher.totalRowValid'))} {importErrors[0].moreInfo.successCount}</div>
                                                <div>{Func.capitalizeFirstLetter(t('item.voucher.totalRowInvalid'))} {importErrors[0].moreInfo.errorCount}</div>
                                                <div className={`import-row-error`}>
                                                    {
                                                        importErrors[0].moreInfo.alreadyExists.checkCode &&
                                                        (<div><b>- {Func.capitalizeFirstLetter(t('item.voucher.checkCode'))}</b> {Func.capitalizeFirstLetter(t('item.voucher.alreadyExist')).toLowerCase()} {importErrors[0].moreInfo.alreadyExists.checkCode}</div>)
                                                    }
                                                    {
                                                        importErrors[0].moreInfo.duplicateData.checkCode && importErrors[0].moreInfo.duplicateData.checkCode.length > 0 &&
                                                        (<div><b>- {Func.capitalizeFirstLetter(t('item.voucher.checkCode'))}</b> {Func.capitalizeFirstLetter(t('item.voucher.dataDuplicate')).toLowerCase()} ({importErrors[0].moreInfo.duplicateData.checkCode.join('); (')})</div>)
                                                    }
                                                    {
                                                        importErrors[0].moreInfo.alreadyExists.voucherCode &&
                                                        (<div><b>- {Func.capitalizeFirstLetter(t('item.voucher.voucherCode'))}</b> {Func.capitalizeFirstLetter(t('item.voucher.alreadyExist')).toLowerCase()} {importErrors[0].moreInfo.alreadyExists.voucherCode}</div>)
                                                    }
                                                    {
                                                        importErrors[0].moreInfo.duplicateData.voucherCode && importErrors[0].moreInfo.duplicateData.voucherCode.length > 0 &&
                                                        (<div><b>- {Func.capitalizeFirstLetter(t('item.voucher.voucherCode'))}</b> {Func.capitalizeFirstLetter(t('item.voucher.dataDuplicate')).toLowerCase()} ({importErrors[0].moreInfo.duplicateData.voucherCode.join('); (')})</div>)
                                                    }
                                                    {
                                                        importErrors[0].moreInfo.dataError &&
                                                        (<div>- {Func.capitalizeFirstLetter(t('item.voucher.dataError'))} {importErrors[0].moreInfo.dataError}</div>)
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        importData && importData.success && (
                                            <div className="col-md-12 import-success-contain">
                                                <div><h3>{Func.capitalizeFirstLetter(t('item.voucher.importSuccess'))} </h3></div>
                                                <div>{Func.capitalizeFirstLetter(t('item.voucher.totalCount'))} {importData.totalCount}</div>
                                            </div>
                                        )
                                    }
                                </div>
                            </HMS.FormWrapperItem>

                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        vouchers: state.voucherReducer,
        products: state.productReducer,
        groups: state.groupReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListAllGroups: (filters) => {
            dispatch(action.dataAllGroupAction(filters))
        },
        onImportVoucher: (params) => {
            dispatch(action.importVoucherAction(params))
        },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ImportComponent)));
